const getEnabledBTCUnit = (
  ismBTCEnabled?: boolean,
  isuBTCEnabled?: boolean,
) => {
  if (ismBTCEnabled && !isuBTCEnabled) {
    return 'mBTC';
  }
  if (isuBTCEnabled && !ismBTCEnabled) {
    return 'uBTC';
  }
  return '';
};

export default getEnabledBTCUnit;
